import { Routes, Route, useLocation } from "react-router-dom";
import NavBar from "./components/navBar/navBar";
import Footer from "./components/footer/footer";
import LiveAuction from "./pages/liveAuction/liveAuction";
import Auctions from "./pages/auctions/auctions";
import AboutUs from "./pages/aboutUs/aboutUs";
import DashBoard from "./pages/dashboard/dashboard";
import OpenAuction from "./pages/openAuction/openAuction";
import Privacy from "./pages/privacy/privacy";
import Terms from "./pages/terms/terms";
import Home from "./pages/home/home";

// ── Promotional mode ──────────────────────────────────────────────────────────
// The following imports are kept for future use when the web app is restored.
// import camel from "./assets/camel.gif";
// import SignIn from "./pages/signIn/signIn";
// import SignUp from "./pages/signup/signup";
// import OTP from "./pages/otp/otp";
// import LiveAuctionRequest from "./pages/liveAuctionRequest/liveAuctionRequest";
// import Checkout from "./pages/checkout/checkout";
// import ConfirmOrder from "./pages/confirmOrder/confirmOrder";
// import Test from "./pages/test/test";
// import Test2 from "./pages/test2/test2";
// ─────────────────────────────────────────────────────────────────────────────

function MainContent() {
  const location = useLocation();

  const isLiveAuction = location.pathname.startsWith("/liveAuction");
  const isDashBoard = location.pathname.startsWith("/dashboard");

  return (
    <>
      {!isLiveAuction && !isDashBoard && <NavBar />}

      <Routes>
        {/* ── Promotional routes ── */}
        <Route path="/" element={<Home />} />
        <Route path="/auctions" element={<Auctions />} />
        <Route path="/liveAuction/:id" element={<LiveAuction />} />
        <Route path="/openAuction/:id" element={<OpenAuction />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />

        {/* ── Dashboard — kept as-is ── */}
        <Route path="/dashboard" element={<DashBoard />} />

        {/* ── Web-app routes (disabled for promotional mode) ──
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/otp" element={<OTP />} />
        <Route path="/requestLiveAuction" element={<LiveAuctionRequest />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/confirmOrder/:orderId" element={<ConfirmOrder />} />
        <Route path="/test" element={<Test />} />
        <Route path="/test2" element={<Test2 />} />
        ── */}
      </Routes>

      {!isLiveAuction && !isDashBoard && <Footer />}
    </>
  );
}

export default MainContent;
